export default __webpack_public_path__ + "static/media/gold_image_4.51037635.jpg";